import React from 'react';

const HomeV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.29117 9.44898C2.29117 8.91732 2.51682 8.41063 2.91201 8.05497L8.74675 2.8037C9.45999 2.16178 10.5427 2.16178 11.256 2.8037L17.0907 8.05497C17.4859 8.41063 17.7116 8.91732 17.7116 9.44898V15.8371C17.7116 16.8729 16.8719 17.7126 15.8361 17.7126H4.16662C3.13083 17.7126 2.29117 16.8729 2.29117 15.8371V9.44898Z",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.5032 17.5042V12.503C12.5032 12.0426 12.13 11.6694 11.6696 11.6694H8.33549C7.87514 11.6694 7.50195 12.0426 7.50195 12.503V17.5042",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  )
);

export { HomeV2 };
//# sourceMappingURL=HomeV2.js.map
